const WeightLossStats = () => {
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 mt-4 text-main-button-v2">
      <div className="rounded-xl bg-purple-light-v2 p-6 text-left border border-stroke-v2">
        <p className="text-base font-semibold">
          Studies show an average weight loss of
        </p>
        <p className="text-[44px] font-bold">27.1 lbs</p>
        <p className="text-base font-medium">
          in the first 6 months
        </p>
      </div>
      <div className="rounded-xl bg-purple-light-v2 p-6 text-left border border-stroke-v2">
        <p className="text-base font-semibold">
          Experience an average weight loss of
        </p>
        <p className="text-[44px] font-bold">14.9%</p>
        <p className="text-base font-medium">
          within a year with a GLP-1 Medication
        </p>
      </div>
    </div>
  );
};

export { WeightLossStats };
